import heroPrimary from "../assets/content-hero.png";

const TelegramPage = () => {
  const featureList = [
    {
      title: "Signal Gratis",
      desc: "Notifikasi langsung saat peluang entry muncul dengan detail TP/SL.",
    },
    {
      title: "Market Outlook",
      desc: "Analisa market pagi + reminder level penting sepanjang hari.",
    },
    {
      title: "Community Support",
      desc: "Belajar dan sharing strategi bersama ribuan trader lainnya.",
    },
  ];

  const proChannels = [
    {
      title: "ARFA FX MARKET UPDATE",
      tag: "Berita Pasar Dunia",
      desc: "Kurasi headline makro, rilis data penting, dan sentimen global untuk bantu kamu ambil keputusan lebih cepat.",
      href: "https://t.me/arfafxmarketupdate",
      accent: "from-[#ff00bf]/80 to-[#ff8bff]/30",
    },
    {
      title: "ARFA FX OUTLOOK",
      tag: "Mapping Teknis",
      desc: "Focus pada level demand/supply, area entry, dan proyeksi intraday siap pakai.",
      href: "https://t.me/arfafxoutlook",
      accent: "from-[#7b5bff]/80 to-[#dac7ff]/20",
    },
  ];

  return (
    <>
      <section className="relative overflow-hidden bg-gradient-to-b from-[#14001f] via-[#0a0013] to-[#040005] px-6 py-28">
        <div className="absolute inset-x-0 top-0 mx-auto h-72 w-72 rounded-full bg-[#ff00bf]/20 blur-[220px]" />
        <div className="absolute inset-x-0 bottom-0 mx-auto h-72 w-72 rounded-full bg-[#5a17ff]/20 blur-[200px]" />

        <div className="relative mx-auto max-w-6xl space-y-16 text-center text-white">
          <div className="space-y-4">
            <p className="inline-flex rounded-full border border-[#ff7aec] px-4 py-1 text-xs uppercase tracking-[0.4em] text-[#ff7aec]">
              ArfaFX Community
            </p>
            <h1 className="text-4xl font-black tracking-tight sm:text-5xl">Gabung ke Channel Telegram Umum</h1>
            <p className="mx-auto max-w-3xl text-base text-white/70">
              Dapatkan signal harian, live trade setup, dan akses mentor setiap hari langsung dari channel Telegram ArfaFX.
            </p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {featureList.map((item, index) => (
              <div
                key={item.title}
                className="rounded-[32px] border border-white/10 bg-white/5/60 from-white/10 to-transparent p-6 text-left shadow-[0_35px_80px_rgba(0,0,0,0.35)] backdrop-blur-md transition hover:-translate-y-1"
                style={{
                  background:
                    index % 2 === 0
                      ? "linear-gradient(145deg, rgba(255,255,255,0.08), rgba(255,255,255,0.02))"
                      : "linear-gradient(145deg, rgba(255,0,191,0.08), rgba(255,255,255,0.02))",
                }}
              >
                <p className="text-xs uppercase tracking-[0.35em] text-white/60">Benefit</p>
                <h3 className="mt-3 text-2xl font-semibold text-white">{item.title}</h3>
                <p className="mt-3 text-sm text-white/70">{item.desc}</p>
              </div>
            ))}
          </div>

          <a
            href="https://t.me/arfatradingforex"
            className="inline-flex rounded-full bg-gradient-to-r from-[#ff00bf] via-[#ff6bff] to-[#ffc4ff] px-10 py-3 text-base font-semibold text-white shadow-[0_20px_60px_rgba(255,0,191,0.35)]  hover:scale-[1.1] transition-transform"
            target="_blank"
            rel="noreferrer"
          >Buka Telegram
          </a>

          <div className="space-y-8 text-center">
            <div className="space-y-4">
              <h2 className="text-3xl font-black text-white sm:text-4xl">Sub Channel ArfaFX</h2>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              {proChannels.map((channel) => (
                <div
                  key={channel.title}
                  className={`relative overflow-hidden rounded-[32px] border border-white/10 bg-gradient-to-br ${channel.accent} p-8 shadow-[0_30px_90px_rgba(0,0,0,0.45)]`}
                >
                  <div className="text-xs uppercase tracking-[0.35em] text-white/80">{channel.tag}</div>
                  <h3 className="mt-4 text-2xl font-bold leading-tight">{channel.title}</h3>
                  <p className="mt-4 text-sm text-white/80">{channel.desc}</p>
                  <a
                    href={channel.href}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/95 px-6 py-2 text-sm font-semibold text-black shadow-[0_10px_25px_rgba(0,0,0,0.15)] transition hover:bg-white"
                  >
                    Join Channel
                    <span aria-hidden>↗</span>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-r from-[#ff00bf] via-[#ff6bff] to-[#ffc4ff] py-16 text-black">
        <div className="mx-auto flex max-w-6xl flex-col gap-8 px-6 lg:flex-row lg:items-center">
          <div className="flex-1 space-y-4">
            <p className="inline-flex rounded-full border border-black/50 px-4 py-1 text-xs uppercase tracking-[0.3em] text-black">
              Dapatkan semua akses
            </p>
            <h2 className="text-3xl font-black">
              Jadilah Trader Profesional dan Raihlah Profit Maksimal!
            </h2>
            <p className="text-black/70">
              Ribuan member sudah berhasil profit maksimal dan konsisten dengan strategi dari ArfaFX. Saatnya giliran kamu!!
            </p>
            <div className="mt-6 flex flex-wrap gap-4">
              <a
                href="https://t.me/joinpremiumarfafx"
                className="rounded-full bg-black px-8 py-3 text-sm font-semibold text-white shadow-[0_15px_40px_rgba(0,0,0,0.3)] transition-transform hover:scale-[1.1] hover:bg-black hover:text-white"
              >
                Gabung Sekarang
              </a>
              <a
                href="https://t.me/arfatradingforex"
                className="rounded-full border border-black px-8 py-3 text-sm font-semibold text-black transition-transform hover:scale-[1.1] hover:bg-black hover:text-white"
              >
                Join Free Channel
              </a>
            </div>
          </div>
          <div className="flex-1">
            <img src={heroPrimary} alt="Komunitas ArfaFX" className="w-full object-cover" />
          </div>
        </div>
      </section>
    </>
  );
};

export default TelegramPage;

